module.exports = __webpack_public_path__ + "teqbahn-assets/media/31.47280611.png";